module.exports = "/images/pdf-fileicon.svg?468969859e2cf1b27730ea10b42cffcb";